import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "../component/layout/header";
import Footer from "../component/layout/footer";
import "../assets/css/tutorcss/ExperiencePage.css"

const ExperiencePage = () => {
  const { exp } = useParams();
  const [tutors, setTutors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");

    fetch(`https://kalakakshaaha.com/kks/api/v1/tutors/experience/${exp}`)
      .then(res => res.json())
      .then(data => {
        if (data.tutors && data.tutors.length > 0) {
          setTutors(data.tutors);
        } else {
          setTutors([]);
          setError(`No tutors found with ${exp} experience`);
        }
        setLoading(false);
      })
      .catch(() => {
        setError("Unable to fetch tutors. Please try again.");
        setLoading(false);
      });
  }, [exp]);

  return (
    <>
      <Header />

      <section className="experience-section">
        <div className="container" style={{marginTop:"100px"}}>
          <h2 className="page-title">Tutors With {exp} Experience</h2>

          {loading && <p className="loading-text">Loading tutors…</p>}
          {error && <p className="error-text">{error}</p>}

          <div className="tutor-grid">
            {tutors.map((tutor, index) => (
              <div key={index} className="tutor-card">

                {/* Profile Image */}
                <div className="tutor-img-box">
                  <img
                    src={tutor.image || "/defaultProfile.png"}
                    alt={tutor.username}
                    className="tutor-img"
                  />
                </div>

                <h3 className="tutor-name">{tutor.username}</h3>

                <p className="tutor-subject">
                  {tutor.subject || "Specialized Tutor"}
                </p>

                <div className="tutor-details">
                  <span className="badge exp-badge">
                    {tutor.experience} Years Exp
                  </span>
                  <span className="badge city-badge">
                    {tutor.city}
                  </span>
                </div>

                <button className="view-btn">View Profile</button>

              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ExperiencePage;
